"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefensiveMidfielderRoleBonuses = exports.DefensiveMidfielderExpandedRoles = void 0;
// defensiveMidfielderRoles.ts
const playerBonuses_1 = require("../playerBonuses");
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var DefensiveMidfielderExpandedRoles;
(function (DefensiveMidfielderExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent with other positions)
    DefensiveMidfielderExpandedRoles["RAPID_DEFENSIVE_MIDFIELDER"] = "RAPID_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["POWERFUL_DEFENSIVE_MIDFIELDER"] = "POWERFUL_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["TIRELESS_DEFENSIVE_MIDFIELDER"] = "TIRELESS_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["DETERMINED_DEFENSIVE_MIDFIELDER"] = "DETERMINED_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["HEROIC_DEFENSIVE_MIDFIELDER"] = "HEROIC_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["ECCENTRIC_DEFENSIVE_MIDFIELDER"] = "ECCENTRIC_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["RELIABLE_DEFENSIVE_MIDFIELDER"] = "RELIABLE_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["LUCKY_DEFENSIVE_MIDFIELDER"] = "LUCKY_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["TENACIOUS_DEFENSIVE_MIDFIELDER"] = "TENACIOUS_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["INSPIRATIONAL_DEFENSIVE_MIDFIELDER"] = "INSPIRATIONAL_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["DOMINANT_DEFENSIVE_MIDFIELDER"] = "DOMINANT_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["IMPACT_DEFENSIVE_MIDFIELDER"] = "IMPACT_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["PRESSING_DEFENSIVE_MIDFIELDER"] = "PRESSING_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["STUBBORN_DEFENSIVE_MIDFIELDER"] = "STUBBORN_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["VOCAL_DEFENSIVE_MIDFIELDER"] = "VOCAL_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["RETENTIVE_DEFENSIVE_MIDFIELDER"] = "RETENTIVE_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["EXPERIENCED_DEFENSIVE_MIDFIELDER"] = "EXPERIENCED_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["FIREY_DEFENSIVE_MIDFIELDER"] = "FIREY_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["VERSATILE_DEFENSIVE_MIDFIELDER"] = "VERSATILE_DEFENSIVE_MIDFIELDER";
    // --- Uncommon --- DM SPECIFIC / FUNCTIONAL
    DefensiveMidfielderExpandedRoles["DEEP_LYING_PLAYMAKER"] = "DEEP_LYING_PLAYMAKER";
    DefensiveMidfielderExpandedRoles["SECURE_DEFENSIVE_MIDFIELDER"] = "SECURE_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["SHIELDING_DEFENSIVE_MIDFIELDER"] = "SHIELDING_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["ORCHESTRATING_DEFENSIVE_MIDFIELDER"] = "ORCHESTRATING_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["SILKY_DEFENSIVE_MIDFIELDER"] = "SILKY_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["STAR_DEFENSIVE_MIDFIELDER"] = "STAR_DEFENSIVE_MIDFIELDER";
    // --- Rare --- GENERIC COMBINATIONS (Two basic traits)
    DefensiveMidfielderExpandedRoles["ATHLETIC_DEFENSIVE_MIDFIELDER"] = "ATHLETIC_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["ENERGETIC_DEFENSIVE_MIDFIELDER"] = "ENERGETIC_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["VALIANT_DEFENSIVE_MIDFIELDER"] = "VALIANT_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["PLUCKY_DEFENSIVE_MIDFIELDER"] = "PLUCKY_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["ROBUST_DEFENSIVE_MIDFIELDER"] = "ROBUST_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["AGGRESSIVE_DEFENSIVE_MIDFIELDER"] = "AGGRESSIVE_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["GEGENPRESSING_DEFENSIVE_MIDFIELDER"] = "GEGENPRESSING_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["COMMANDING_DEFENSIVE_MIDFIELDER"] = "COMMANDING_DEFENSIVE_MIDFIELDER";
    DefensiveMidfielderExpandedRoles["ROUSING_DEFENSIVE_MIDFIELDER"] = "ROUSING_DEFENSIVE_MIDFIELDER";
    // --- Rare --- ARCHETYPAL DEFENSIVE MIDFIELDERS
    DefensiveMidfielderExpandedRoles["REGISTA"] = "REGISTA";
    DefensiveMidfielderExpandedRoles["ANCHOR"] = "ANCHOR";
    DefensiveMidfielderExpandedRoles["COMMANDING_ANCHOR"] = "COMMANDING_ANCHOR";
    DefensiveMidfielderExpandedRoles["DESTROYER"] = "DESTROYER";
    DefensiveMidfielderExpandedRoles["SPACE_EATER"] = "SPACE_EATER";
})(DefensiveMidfielderExpandedRoles || (exports.DefensiveMidfielderExpandedRoles = DefensiveMidfielderExpandedRoles = {}));
exports.DefensiveMidfielderRoleBonuses = {
    [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            intercept: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            tackle: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            pass: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.DEFENSE, zones_1.Zones.MIDFIELD],
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [DefensiveMidfielderExpandedRoles.RAPID_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Speed to intercept
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [DefensiveMidfielderExpandedRoles.POWERFUL_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Power in the tackle
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [DefensiveMidfielderExpandedRoles.TIRELESS_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Stamina to cover ground (Run is less primary for DM, but fits Stamina)
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [DefensiveMidfielderExpandedRoles.DETERMINED_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Determined interceptions
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [DefensiveMidfielderExpandedRoles.HEROIC_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Heroic defensive action
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [DefensiveMidfielderExpandedRoles.ECCENTRIC_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Flair passes from deep
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [DefensiveMidfielderExpandedRoles.RELIABLE_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Reliable passing out
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [DefensiveMidfielderExpandedRoles.LUCKY_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Lucky interception
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [DefensiveMidfielderExpandedRoles.TENACIOUS_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Tenacity in the tackle
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [DefensiveMidfielderExpandedRoles.INSPIRATIONAL_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring teammates through control/passing
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [DefensiveMidfielderExpandedRoles.DOMINANT_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominating challenges
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [DefensiveMidfielderExpandedRoles.IMPACT_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Sub to solidify midfield defensively
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [DefensiveMidfielderExpandedRoles.PRESSING_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Pressing high to intercept
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.PRESSING], // Assuming PlayerTraits.PRESSING exists
    },
    [DefensiveMidfielderExpandedRoles.STUBBORN_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Hard to beat in a tackle
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [DefensiveMidfielderExpandedRoles.VOCAL_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Organisation leads to better positioning/interceptions
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [DefensiveMidfielderExpandedRoles.RETENTIVE_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good at keeping ball after winning it
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SECURE_POSSESSION],
    },
    [DefensiveMidfielderExpandedRoles.EXPERIENCED_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise positioning and reading of the game
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    [DefensiveMidfielderExpandedRoles.FIREY_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [DefensiveMidfielderExpandedRoles.VERSATILE_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- Uncommon --- DM SPECIFIC / FUNCTIONAL ---
    [DefensiveMidfielderExpandedRoles.DEEP_LYING_PLAYMAKER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [DefensiveMidfielderExpandedRoles.SECURE_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Resisting press often involves passing out
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.PRESS_RESISTANT],
    },
    [DefensiveMidfielderExpandedRoles.SHIELDING_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Shielding space, intercepting passes
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SHIELD],
    },
    [DefensiveMidfielderExpandedRoles.ORCHESTRATING_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    [DefensiveMidfielderExpandedRoles.SILKY_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good touch for better passing
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [DefensiveMidfielderExpandedRoles.STAR_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.DEFENSIVE_MIDFIELDER], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Star DM controlling play
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    // --- Rare --- GENERIC COMBINATIONS ---
    [DefensiveMidfielderExpandedRoles.ATHLETIC_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.RAPID_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.POWERFUL_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Athleticism aids interceptions
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.ENERGETIC_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.RAPID_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.TIRELESS_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Covers ground quickly and tirelessly
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.VALIANT_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.DETERMINED_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.HEROIC_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Valiant interceptions/blocks
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.PLUCKY_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.LUCKY_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.TENACIOUS_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Plucky, tenacious tackling
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.ROBUST_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.TENACIOUS_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.POWERFUL_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.AGGRESSIVE_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.TENACIOUS_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.RAPID_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Aggressively closing down to tackle
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.GEGENPRESSING_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.PRESSING_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.ORCHESTRATING_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Pressing leads to intercepts
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.COMMANDING_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.EXPERIENCED_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.VOCAL_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise and organised defensive presence
        positionsEnabled: [], playerTraits: [],
    },
    // --- Rare --- ARCHETYPAL DEFENSIVE MIDFIELDERS ---
    [DefensiveMidfielderExpandedRoles.REGISTA]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.ORCHESTRATING_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.SECURE_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.ANCHOR]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.SHIELDING_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.DEEP_LYING_PLAYMAKER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Holds position and distributes
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.COMMANDING_ANCHOR]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.VOCAL_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.SHIELDING_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Organised, commanding defensive presence
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.DESTROYER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.SHIELDING_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.RETENTIVE_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wins ball and keeps it simply
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.SPACE_EATER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.RAPID_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.SHIELDING_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Covers ground quickly to shield/intercept
        positionsEnabled: [], playerTraits: [],
    },
    [DefensiveMidfielderExpandedRoles.ROUSING_DEFENSIVE_MIDFIELDER]: {
        parentRoles: [DefensiveMidfielderExpandedRoles.INSPIRATIONAL_DEFENSIVE_MIDFIELDER, DefensiveMidfielderExpandedRoles.DETERMINED_DEFENSIVE_MIDFIELDER],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring teammates through control/passing
        positionsEnabled: [], playerTraits: [],
    },
};
